import './App.css';
import { Admin, CustomRoutes } from 'react-admin';
import { Route, Navigate } from 'react-router-dom';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { customTheme } from './theme/customTheme';
import { authProvider } from './Provider/parseAuthProvider';
import { dataProvider } from './Provider/parseDataProvider';
import Login from './pages/auth/Login';
import { CustomLayout } from './layouts/CustomLayout';

import PlayerAccountSearch from './pages/playerAccount/PlayerAccountSearch';
import PlayerSpinSearch from './pages/playerAccount/PlayerSpinSearch';
import PlayerAccounting from './pages/playerAccount/PlayerAccounting';
import AgentCurrencyReport from './pages/reports/AgentCurrencyReport';
import AgentDailyCurrencyReport from './pages/reports/AgentDailyCurrencyReport';
import EditProfile from './pages/profile/EditProfile';
import ChangePassword from './pages/profile/ChangePassword';

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider theme={customTheme}>
        <CssBaseline />
        <Admin
          authProvider={authProvider}
          dataProvider={dataProvider}
          loginPage={Login}
          layout={CustomLayout}
          theme={customTheme}
          requireAuth
          dashboard={() => <Navigate to="/player-account/search" replace />}
        >
          <CustomRoutes>
            <Route path="/player-account/search" element={<PlayerAccountSearch />} />
            <Route path="/player-account/spin-search" element={<PlayerSpinSearch />} />
            <Route path="/player-account/accounting" element={<PlayerAccounting />} />
            <Route path="/reports/agent-currency" element={<AgentCurrencyReport />} />
            <Route path="/reports/agent-daily-currency" element={<AgentDailyCurrencyReport />} />
            <Route path="/profile/edit" element={<EditProfile />} />
            <Route path="/profile/change-password" element={<ChangePassword />} />
          </CustomRoutes>
        </Admin>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
